/* B2B buyers are on contract pricing, so the consumer compare-at ("was") price
 * is suppressed for them. This mirrors snippets/price.liquid, which nils
 * compare_at_price when customer.current_company is set — but collection and
 * search cards are built here in JS and never pass through that snippet, so the
 * two surfaces disagreed without this. Evaluated per render rather than once at
 * load, so script order cannot leave it stale. */
function jendcoHideCompareAt() {
  return !!(window.theme && window.theme.customerIsB2B);
}

/* SECURITY: Algolia hit data (titles, vendors, SKUs) is merchant/catalog data, not
 * trusted markup, and this file interpolates it into quoted HTML attributes below.
 * assets/compare-tool.js and assets/b2b-quick-order-pad.js already declare the same
 * rule; this file renders the same records and was the outlier. Note the practical
 * trigger is ordinary catalogue data, not an attacker: a title like 1/2" Drive
 * terminates the attribute and breaks the card.
 * Safe for both text nodes and quoted attributes. */
function jendcoEsc(value) {
  if (value == null) return '';
  return String(value).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

var JENDCO_ALGOLIA_BLOCKED_BOT_UA = /baiduspider|ahrefsbot|semrushbot|mj12bot|dotbot|petalbot|blexbot|scrapy|python|curl|wget|headless|phantom|selenium|playwright/i;

if (JENDCO_ALGOLIA_BLOCKED_BOT_UA.test(navigator.userAgent)) {
  console.warn('Algolia disabled for crawler user agent:', navigator.userAgent);
  window.JENDCO_DISABLE_ALGOLIA = true;
}

if (!window.JENDCO_DISABLE_ALGOLIA) {

const urlParams = new URLSearchParams(window.location.search);
const initialQuery = urlParams.get('query') || '';
const suggestionContainer = document.querySelector('.search_collection-link__inner');
const suggestcollcontainer = document.querySelector('.search-suggestion-tab');
const isSearchPage = window.location.pathname === '/search';
var hide_filters = algolia_customs.hide_filters.split(',').map(item => item.toLowerCase().trim());
// var hide_filters = '';

const JENDCO_ALGOLIA_PROXY_URL = 'https://jendco-algolia-proxy.myron-2e0.workers.dev';

const searchClient = {
  search: function(requests) {
    return fetch(`${JENDCO_ALGOLIA_PROXY_URL}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Jendco-Search-Client': 'storefront'
      },
      body: JSON.stringify({ requests: requests })
    }).then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error('Algolia proxy search failed: ' + response.status + ' ' + text);
        });
      }
      return response.json();
    });
  },

  searchForFacetValues: function(requests) {
    return fetch(`${JENDCO_ALGOLIA_PROXY_URL}/sffv`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Jendco-Search-Client': 'storefront'
      },
      body: JSON.stringify({ requests: requests })
    }).then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error('Algolia proxy SFFV failed: ' + response.status + ' ' + text);
        });
      }
      return response.json();
    });
  },

  addAlgoliaAgent: function() {
    // InstantSearch calls this on Algolia clients. No-op for proxy client.
  }
};;

// Collection pages ship a server-rendered first page of products with real
// ?page=N links (sections/algolia-product-list.liquid), because crawlers and
// visitors whose search request fails need products in the HTML. On collection
// pages the Algolia page number therefore lives in the same `page` parameter,
// so /collections/x?page=3 opens Algolia on page 3, and Algolia's own pagination
// links are ?page=N URLs that also work, and render, without JavaScript. Every
// other piece of state (refinements, sort, query) keeps the default
// jendco-shopify_products[...] format. Search pages keep the default router.
const ALGOLIA_INDEX_NAME = 'jendco-shopify_products';
const collectionPageRouter = () => instantsearch.routers.history({
  parseURL({ qsModule, location }) {
    const routeState = qsModule.parse(location.search.slice(1), { arrayLimit: 99 });
    const shopifyPage = parseInt(routeState.page, 10);
    delete routeState.page;
    if (shopifyPage > 1) {
      const indexState = routeState[ALGOLIA_INDEX_NAME] || {};
      // An explicit Algolia page (old bookmarked URLs) wins over ?page=.
      if (indexState.page == null) indexState.page = shopifyPage;
      routeState[ALGOLIA_INDEX_NAME] = indexState;
    }
    return routeState;
  },
  createURL({ qsModule, routeState, location }) {
    const { protocol, hostname, port = '', pathname, hash } = location;
    const state = Object.assign({}, routeState);
    const indexState = Object.assign({}, state[ALGOLIA_INDEX_NAME] || {});
    const page = parseInt(indexState.page, 10);
    delete indexState.page;
    if (Object.keys(indexState).length) {
      state[ALGOLIA_INDEX_NAME] = indexState;
    } else {
      delete state[ALGOLIA_INDEX_NAME];
    }
    let queryString = qsModule.stringify(state);
    if (page > 1) queryString += (queryString ? '&' : '') + 'page=' + page;
    const portWithPrefix = port === '' ? '' : `:${port}`;
    return `${protocol}//${hostname}${portWithPrefix}${pathname}${queryString ? '?' + queryString : ''}${hash}`;
  },
});

// Who owns the collection grid.
//
// sections/algolia-product-list.liquid renders the collection's products and
// ?page=N pagination into the HTML. For an ordinary collection URL (no filter,
// sort or search) that server grid IS the page: Algolia still runs for the
// filter sidebar and the product count, but its results and pagination widgets
// are not mounted, so nothing replaces what the shopper is reading. They mount
// when the shopper deliberately filters, sorts or searches, or when the URL
// already carries such state, and they replace the server blocks in the same
// task they first render. Returning to the unfiltered state reloads the server
// page rather than showing Algolia's differently ranked list at the same URL.
const serverOwnsGrid = !!document.querySelector('#ProductGridContainer[data-collection-ssr]');
// A buyer restricted to their company's My Items (b2b-catalog-scope.js). Their
// Algolia filter is narrowed to the list, while the server grid is the whole
// collection with every other product hidden page by page, so Algolia owns such a
// buyer's grid from the start, as it does for a URL carrying filter state, and
// keeps it: clearing filters or changing page stays in Algolia, no reload.
const algoliaOwnsRestrictedGrid = serverOwnsGrid &&
  typeof window.jendcoB2BSearchNarrowed === 'function' && window.jendcoB2BSearchNarrowed();
const urlCarriesAlgoliaState = () => /(^|[?&])jendco-shopify_products(\[|%5B)/i.test(window.location.search);
const gridWrapper = document.getElementById('ProductGridWrapper');

// True when the collection state is just "browse this collection", page aside.
const isPristineCollectionState = (uiState) => {
  const indexState = (uiState && uiState[ALGOLIA_INDEX_NAME]) || {};
  return Object.keys(indexState).every((key) => {
    if (key === 'page' || key === 'configure') return true;
    const value = indexState[key];
    if (value == null || value === '') return true;
    if (key === 'sortBy') return value === ALGOLIA_INDEX_NAME;
    if (typeof value === 'object') {
      return Object.keys(value).every((inner) => {
        const v = value[inner];
        return v == null || v === '' || (Array.isArray(v) && v.length === 0);
      });
    }
    return false;
  });
};

const collectionListingURL = (uiState) => {
  const page = parseInt(((uiState && uiState[ALGOLIA_INDEX_NAME]) || {}).page, 10);
  return window.location.pathname + (page > 1 ? '?page=' + page : '');
};

// Remove the server-rendered grid and pagination the first time Algolia's results
// widget has fresh results to paint, and unhide Algolia's roots. Called from the
// hits widget's transformItems, which runs in the same task as the hits and
// pagination widgets render, so there is no second grid and no empty frame.
let serverRenderedGridReleased = false;
const releaseServerRenderedGrid = () => {
  if (serverRenderedGridReleased) return;
  serverRenderedGridReleased = true;
  document.querySelectorAll('[data-collection-ssr-grid], [data-collection-ssr-pagination]').forEach((el) => el.remove());
  if (gridWrapper) {
    gridWrapper.classList.remove('collection-ssr-pending');
    gridWrapper.classList.add('collection-ssr-released');
  }
};

// A URL carrying Algolia state is marked pending by the section's inline script,
// so the unfiltered server products are not presented as a filtered result. That
// script owns the recovery (its timer, and its DOMContentLoaded check that this
// file started the search), so the products cannot stay hidden if this file never
// runs. Here: when a search for filter/sort state fails, show them again with the
// notice that they are unfiltered. (A failure on an ordinary URL needs nothing:
// the server products are already showing and are what that URL means.)
const ssrGridControl = serverOwnsGrid ? (window.jendcoCollectionSsr || null) : null;

let collectionGridHits;
let collectionGridPagination;
let gridWidgetsMounted = false;
const mountGridWidgets = () => {
  if (gridWidgetsMounted || !collectionGridHits) return;
  gridWidgetsMounted = true;
  search.addWidgets([collectionGridHits, collectionGridPagination]);
};

// Algolia's results and pagination render into roots of their own beside the
// server blocks, never into the containers that hold them: InstantSearch's first
// render into a container takes over whatever is already inside. The roots stay
// hidden (algolia-product-list.css) until releaseServerRenderedGrid() marks the
// wrapper released, and the hits widget ignores stale renders until then (see
// transformItems), so only results for the shopper's new state ever replace the
// server products.
const algoliaWidgetRoot = (containerId, className) => {
  const container = document.getElementById(containerId);
  if (!serverOwnsGrid || !container) return '#' + containerId;
  const root = document.createElement('div');
  root.className = className;
  container.appendChild(root);
  return root;
};
const algoliaGridRoot = algoliaWidgetRoot('ProductGridContainer', 'collection-algolia-grid');
const algoliaPaginationRoot = algoliaWidgetRoot('pagination', 'collection-algolia-pagination');

// A render is stale when InstantSearch repaints the results it already holds
// while a new search is in flight ('loading', 'stalled' after 200 ms) or failed
// ('error'). Newly mounted widgets would paint the sidebar's unfiltered results.
const isFreshRender = () => search.status === 'idle';

const revealServerRenderedGrid = () => {
  if (!ssrGridControl || serverRenderedGridReleased) return;
  if (gridWidgetsMounted || urlCarriesAlgoliaState()) {
    // Quiet for a restricted buyer who has not filtered: no filter failed to apply.
    const quiet = algoliaOwnsRestrictedGrid && !urlCarriesAlgoliaState() &&
      isPristineCollectionState(search.getUiState());
    ssrGridControl.reveal(quiet);
  }
};

// Back/Forward. The router applies URL state without going through
// onStateChange, so ownership is re-checked here.
if (serverOwnsGrid) {
  window.addEventListener('popstate', () => {
    if (urlCarriesAlgoliaState()) {
      if (!gridWidgetsMounted && ssrGridControl) ssrGridControl.pend();
      mountGridWidgets();
    } else if (gridWidgetsMounted && !algoliaOwnsRestrictedGrid) {
      window.location.reload();
    }
  });
}

const search = instantsearch({
  indexName: ALGOLIA_INDEX_NAME,
  searchClient: searchClient,
  routing: algolia_customs.collection ? { router: collectionPageRouter() } : true,
  onStateChange({ uiState, setUiState }) {
    if (serverOwnsGrid && !algoliaOwnsRestrictedGrid && isPristineCollectionState(uiState) && gridWidgetsMounted) {
      window.location.assign(collectionListingURL(uiState));
      return;
    }
    setUiState(uiState);
    if (serverOwnsGrid && !isPristineCollectionState(uiState)) mountGridWidgets();
  },
  initialUiState: {
    shopify_products: {
      query: initialQuery,
    },
  },
});

const search_popular = instantsearch({
  indexName: 'jendco-shopify_products',
  searchClient: algoliasearch('SRQQCVINL7', 'cc4c95e5f685f38dcb80d39dac620913'),
});

const qsClient = algoliasearch(
  "SRQQCVINL7",
  "cc4c95e5f685f38dcb80d39dac620913"
).initIndex('jendco-shopify_products_query_suggestions');

const qscollClient = algoliasearch(
  "SRQQCVINL7",
  "cc4c95e5f685f38dcb80d39dac620913"
).initIndex('jendco-shopify_collections');

const {
  refinementList,
  dynamicWidgets,
  menu,
  hierarchicalMenu,
  searchBox,
  hits,
  pagination,
  configure,
  currentRefinements,
  clearRefinements,
} = instantsearch.widgets;
const {
  connectSortBy,
  connectSearchBox,
  connectStats,
  connectRange,
  connectCurrentRefinements,
  connectClearRefinements,
} = instantsearch.connectors;

const facetsWrappermobile = document.querySelectorAll('.mobile-facets__main-items ');
let sideFilterWrapper = document.querySelectorAll('.facets__wrapper-container');

const searchFilters = () => {
  let parts = [];

  if (algolia_customs.collection) {
    parts.push("collections:" + algolia_customs.handle);
  }

  // B2B catalog scoping: when a B2B buyer is logged in for a company location,
  // restrict results to products published to that location's catalog. Backed
  // by the auto-synced product metafield custom.b2b_location_ids (indexed in
  // Algolia as meta.custom.b2b_location_ids).
  parts.push((function () {
      /* b2b-catalog-scope.js owns this filter; the inline fallback keeps the
       * page working if that asset fails to load. */
      if (typeof window.jendcoB2BFilter === 'function') return window.jendcoB2BFilter();
      var l = window.algoliaB2B && (window.algoliaB2B.locationId || window.algoliaB2B.rawLocationId);
      var a = 'meta.custom.b2b_location_ids';
      return ['tags:"b2b-only"', a + ':"restricted"'].map(function (m) {
        return l ? '(NOT ' + m + ' OR ' + a + ':"' + l + '")' : 'NOT ' + m;
      }).join(' AND ');
    })());

  return parts.join(" AND ");
};

const renderStats = (renderOptions, isFirstRender) => {
  const {
    nbHits,
    areHitsSorted,
    nbSortedHits,
    processingTimeMS,
    query,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    return;
  }

  let count = "";
  let resultsText = "Results";

  //console.log('state call')

  if (areHitsSorted) {
    if (nbSortedHits > 1) {
      count = `${nbSortedHits}`;
    } else if (nbSortedHits === 1) {
      count = "1";
    } else {
      count = "No";
    }
    count += ` out of ${nbHits}`;
  } else {
    if (nbHits > 1) {
      count += `${nbHits}`;
    } else if (nbHits === 1) {
      count += "1";
    } else {
      count += "no result";
    }
  }
  widgetParams.container.setAttribute('data-count',count);
  if (query == " " || query == "") {
    widgetParams.container.innerHTML = `${count} products`;
  }else if(count == 'no result'){
    widgetParams.container.innerHTML = `0 products`;
  }else {
    widgetParams.container.innerHTML = `Showing ${nbHits} of ${count} products`;
  }

  
  
};

const renderSortBy = (renderOptions1, isFirstRender1) => {
  const { options, currentRefinement, refine, widgetParams, canRefine } =
  renderOptions1;

  if (isFirstRender1) {
    const select = document.createElement("ul");

    widgetParams.container.appendChild(select);

    const select2 = widgetParams.container.querySelector("ul");

    select2.classList.add("sort-by-dropdown");
    select2.classList.add("sort-options");
    select2.disabled = !canRefine;

    select2.innerHTML = `${options
      .map(
        (option) =>
          `<li onclick="closeActive(this)" data-value="${option.value}" class="${
            option.value === currentRefinement ? "active" : ""
          }"><span class="redio-icon"></span>${option.label}</li>`
      )
      .join("")}`;

    select.querySelectorAll("li").forEach(function (e) {
      e.addEventListener("click", (event) => {
        const li = event.currentTarget;
        document
          .querySelector("#sort-by1 li.active")
          ?.classList.remove("active");
        // event.target.classList.add("active");
        li.classList.add("active");
        // refine(event.target.dataset.value);
        refine(li.dataset.value);
      });
    });
  }
};

const renderSortBy2 = (renderOptions2, isFirstRender2) => {
  const { options, currentRefinement, refine, widgetParams, canRefine } =
    renderOptions2;

  if (isFirstRender2) {
    const select = document.createElement("ul");

    widgetParams.container.appendChild(select);

    const select2 = widgetParams.container.querySelector("ul");

    select2.classList.add("sort-by-dropdown");
    select2.classList.add("sort-options");
    select2.disabled = !canRefine;

    select2.innerHTML = `${options
      .map(
        (option) =>
          `<li onclick="closeActive(this)" data-value="${option.value}" class="${
            option.value === currentRefinement ? "active" : ""
          }"><span class="redio-icon"></span>${option.label}</li>`
      )
      .join("")}`;

    select.querySelectorAll("li").forEach(function (e) {
      e.addEventListener("click", (event) => {
        const li = event.currentTarget;
        document
          .querySelector("#sort-by2 li.active")
          ?.classList.remove("active");
        // event.target.classList.add("active");
        li.classList.add("active");
        // refine(event.target.dataset.value);
        refine(li.dataset.value);
      });
    });
  }
};

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear } = renderOptions;

  const container = document.querySelector("#searchbox");

  if (isFirstRender) {
    const box = document.createElement("div");
    const form = document.createElement("form");
    const input = document.createElement("input");
    const button = document.createElement("button");

    box.classList.add("ais-SearchBox");
    button.textContent = `<svg class="ais-SearchBox-resetIcon" viewBox="0 0 20 20" width="20" height="20"><path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path></svg>`;
    form.setAttribute("role", "search");

    input.addEventListener("input", (event) => {
      refine(event.target.value);
    });

    button.addEventListener("click", () => {
      clear();
    });

    form.appendChild(button);
    form.appendChild(input);
    box.appendChild(form);
    container.appendChild(box);
  }

  container.querySelector("input").value = query;
};

const renderRangeSlider = (renderOptions, isFirstRender) => {
  const { start, range, refine, widgetParams } = renderOptions;
  if (isFirstRender) {
    const inputTo = document.createElement("input");
    const inputFrom = document.createElement("input");
    const inputs = document.createElement("div");
    const h1_ele = document.createElement("h1");

    inputTo.type = "range";
    inputTo.setAttribute("aria-label", "Maximum price");
    inputTo.min = 0;
    inputTo.max = Math.ceil(range.max / 5) * 5;
    inputTo.value = Number.isFinite(start[1])
      ? start[1]
      : Math.ceil(range.max / 5) * 5;
    inputTo.step = 5;
    inputTo.id = "toPrice";

    inputFrom.type = "range";
    inputFrom.setAttribute("aria-label", "Minimum price");
    inputFrom.min = 0;
    inputFrom.max = Math.ceil(range.max / 5) * 5;
    inputFrom.value = 0;
    inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
    inputFrom.step = 5;
    inputFrom.id = "fromPrice";

    inputs.id = "priceLabels";

    widgetParams.container.appendChild(inputFrom);
    widgetParams.container.appendChild(inputTo);
    widgetParams.container.parentNode.appendChild(inputs);

    const fromSlider = widgetParams.container.querySelector("#fromPrice");
    const toSlider = widgetParams.container.querySelector("#toPrice");

    toSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPrice");
      const changeTo = document.querySelector("#toPrice");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeFrom.value = 0;
      }
      refine([
        parseFloat(changeFrom.value),
        parseFloat(event.currentTarget.value),
      ]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#000000", changeTo);
    });

    fromSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPrice");
      const changeTo = document.querySelector("#toPrice");

      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeTo.value = changeFrom.max;
      }

      refine([
        parseFloat(event.currentTarget.value),
        parseFloat(changeTo.value),
      ]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#D51317", changeTo);
    });

    fillSlider(fromSlider, toSlider, "#C6C6C6", "#D51317", toSlider);
  }

  const inputTo = widgetParams.container.querySelector("#toPrice");
  const inputFrom = widgetParams.container.querySelector("#fromPrice");

  inputTo.min = 0;
  inputTo.max = Math.ceil(range.max / 5) * 5;
  inputFrom.max = Math.ceil(range.max / 5) * 5;

  inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
  inputTo.value = Number.isFinite(start[1])
    ? start[1]
    : Math.ceil(range.max / 5) * 5;


  widgetParams.container.parentNode.querySelector("#priceLabels").innerHTML = `
    <span>${start[0] == -Infinity ? 0 : start[0]}</span>
    <span>${
      start[1] == Infinity ? Math.ceil(range.max / 5) * 5 : start[1]
    }</span>
  `;

  fillSlider(inputFrom, inputTo, "#C6C6C6", "#D51317", inputTo);
};

const renderRangeSliderMobile = (renderOptions, isFirstRender) => {
  const { start, range, refine, widgetParams } = renderOptions;
  if (isFirstRender) {
    const inputTo = document.createElement("input");
    const inputFrom = document.createElement("input");
    const inputs = document.createElement("div");

    inputTo.type = "range";
    inputTo.setAttribute("aria-label", "Maximum price");
    inputTo.min = 0;
    inputTo.max = Math.ceil(range.max / 5) * 5;
    inputTo.value = Number.isFinite(start[1]) ? start[1] : Math.ceil(range.max / 5) * 5;
    inputTo.step = 5;
    inputTo.id = "toPriceMobile";

    inputFrom.type = "range";
    inputFrom.setAttribute("aria-label", "Minimum price");
    inputFrom.min = 0;
    inputFrom.max = Math.ceil(range.max / 5) * 5;
    inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
    inputFrom.step = 5;
    inputFrom.id = "fromPriceMobile";

    inputs.id = "priceLabels-mobile";

    widgetParams.container.appendChild(inputFrom);
    widgetParams.container.appendChild(inputTo);
    widgetParams.container.parentNode.appendChild(inputs);

    const fromSlider = widgetParams.container.querySelector("#fromPriceMobile");
    const toSlider = widgetParams.container.querySelector("#toPriceMobile");

    toSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPriceMobile");
      const changeTo = document.querySelector("#toPriceMobile");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeFrom.value = 0;
      }
      refine([parseFloat(changeFrom.value), parseFloat(event.currentTarget.value)]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#000000", changeTo);
    });

    fromSlider.addEventListener("change", (event) => {
      const changeFrom = document.querySelector("#fromPriceMobile");
      const changeTo = document.querySelector("#toPriceMobile");
      if (parseFloat(changeTo.value) < parseFloat(changeFrom.value)) {
        changeTo.value = changeFrom.max;
      }
      refine([parseFloat(event.currentTarget.value), parseFloat(changeTo.value)]);
      fillSlider(changeFrom, changeTo, "#C6C6C6", "#D51317", changeTo);
    });

    fillSlider(fromSlider, toSlider, "#C6C6C6", "#D51317", toSlider);
  }

  const inputTo = widgetParams.container.querySelector("#toPriceMobile");
  const inputFrom = widgetParams.container.querySelector("#fromPriceMobile");

  if (!inputTo || !inputFrom) return;

  inputTo.min = 0;
  inputTo.max = Math.ceil(range.max / 5) * 5;
  inputFrom.max = Math.ceil(range.max / 5) * 5;

  inputFrom.value = Number.isFinite(start[0]) ? start[0] : "0";
  inputTo.value = Number.isFinite(start[1]) ? start[1] : Math.ceil(range.max / 5) * 5;

  widgetParams.container.parentNode.querySelector("#priceLabels-mobile").innerHTML = `
    <span>${start[0] == -Infinity ? 0 : start[0]}</span>
    <span>${start[1] == Infinity ? Math.ceil(range.max / 5) * 5 : start[1]}</span>
  `;

  fillSlider(inputFrom, inputTo, "#C6C6C6", "#D51317", inputTo);
};

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, createURL, widgetParams } = renderOptions;

  if (isFirstRender) {
    // Do some initial rendering and bind events
  }

  document.querySelector("#current-refinements").innerHTML = `
    <ul class="ais-CurrentRefinements-list">
      ${items.map(renderListItem).join("")}
    </ul>
  `;

  const clear_buttons = document.querySelectorAll(
    ".ais-CurrentRefinements-category"
  );

  clear_buttons.forEach((element) => {
    element.addEventListener("click", (event) => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      refine(item);

      if (item.attribute == "price") {
        const current_refs = document.querySelectorAll(
          ".ais-CurrentRefinements-category"
        );

        current_refs.forEach((ref) => {
          const ref_data = ref.dataset;
          if (ref_data.attribute == "price") {
            const item2 = Object.keys(ref.dataset).reduce(
              (acc, key) => ({
                ...acc,
                [key]: ref.dataset[key],
              }),
              {}
            );
            refine(item2);
          }
        });

        reset_price();
      }
    });
  });

  if (
    document.querySelectorAll(".ais-CurrentRefinements-category[data-attribute='price']").length <= 0
  ) {
    reset_price();
  }
};

const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine } = renderOptions;

  // --- Desktop clear-all button ---
  const container = document.querySelector("#clear-refinements");
  if (container) {
    if (!hasRefinements) {
      container.innerHTML = "";
    } else {
      // Render a clean button we fully control (no widget state we rely on).
      container.innerHTML = `
        <button type="button" class="ais-ClearRefinements-button makro-clear-all" aria-label="Clear all filters">
          <span>Clear all</span>
        </button>
      `;
      const btn = container.querySelector(".makro-clear-all");
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          refine();
          if (typeof reset_price === "function") {
            try { reset_price(); } catch (err) { /* no-op */ }
          }
        });
      }
    }
  }

  // --- Mobile clear-all button (static markup in the section file) ---
  const mobileBtn = document.querySelector(".mobile-facets__clear");
  if (mobileBtn) {
    if (hasRefinements) {
      mobileBtn.removeAttribute("disabled");
      mobileBtn.classList.remove("is-disabled");
      mobileBtn.style.pointerEvents = "";
      mobileBtn.style.opacity = "";
    } else {
      mobileBtn.setAttribute("disabled", "");
      mobileBtn.classList.add("is-disabled");
      mobileBtn.style.pointerEvents = "none";
      mobileBtn.style.opacity = "0.4";
    }

    // handler always uses the current one (not a stale closure).
    mobileBtn._makroRefine = refine;

    // Only attach the click handler once.
    if (!mobileBtn.dataset.makroWired) {
      mobileBtn.dataset.makroWired = "1";
      mobileBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (typeof mobileBtn._makroRefine === "function") {
          mobileBtn._makroRefine();
        }
        if (typeof reset_price === "function") {
          try { reset_price(); } catch (err) { /* no-op */ }
        }
      });
    }
  }
};

const customClearRefinements = connectClearRefinements(renderClearRefinements);

const customStats = connectStats(renderStats);

const customSortBy = connectSortBy(renderSortBy);

const customSortBy2 = connectSortBy(renderSortBy2);

const customSearchBox = connectSearchBox(renderSearchBox);

const customRangeSlider = connectRange(renderRangeSlider);

const customRangeSliderMobile = connectRange(renderRangeSliderMobile);

const customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements);

const createDataAttribtues = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${jendcoEsc(refinement[key])}"`)
    .join(" ");

const renderListItem = (item) => `<li class="ais-CurrentRefinements-item">${format_current_refined(item)}</li>`;
var close_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.5 3.42334L3.5 12.5696" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.5 12.5696L3.5 3.42334" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  const format_current_refined = (item) => {
    if (item.attribute == "price") {
      return `<button class="ais-CurrentRefinements-category" style="display:none" ${createDataAttribtues(
        item.refinements[0]
        
      )}></button><button class="ais-CurrentRefinements-category" ${createDataAttribtues(
        item.refinements[1]
        
      )}>
        $${jendcoEsc(item.refinements[0].value)} - $${jendcoEsc(item.refinements[1].value)}
        ${close_icon}
      </button>`;
    } else {
      return item.refinements
        .map(
          (refinement) =>
            `<button class="ais-CurrentRefinements-category" ${createDataAttribtues(
              refinement
              
            )}>
            <span class="ais-CurrentRefinements-label">${jendcoEsc(item.attribute
              .replace("meta.algolia.english.", "")
              .replace("meta.algolia.french.", ""))}:</span>${jendcoEsc(refinement.label)}
              ${close_icon}
          </button>`
        )
        .join("");
    }
  };

  const reset_price = () => {
    document.querySelector("#fromPrice").value = 0;
    document.querySelector("#toPrice").value = document.querySelector("#toPrice").getAttribute("max");
    const mobileFrom = document.querySelector("#fromPriceMobile");
    const mobileTo = document.querySelector("#toPriceMobile");
    if (mobileFrom) mobileFrom.value = 0;
    if (mobileTo) mobileTo.value = mobileTo.getAttribute("max");
  };

// Algolia card action helpers: live product hits expose variant count on variants_count
// and the selected Shopify variant ID on objectID.
const getAlgoliaData = (hit) => {
  if (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data) {
    return hit.meta.custom.algolia_data;
  }

  return {};
};

const getAlgoliaVariantCount = (hit) => {
  const algoliaData = getAlgoliaData(hit);
  const count =
    hit.variants_count ||
    hit.variant_count ||
    hit.variantsCount ||
    algoliaData.variants_count ||
    algoliaData.variant_count ||
    algoliaData.variantsCount;

  if (count || count === 0) {
    const parsedCount = parseInt(count, 10);
    if (!isNaN(parsedCount)) {
      return parsedCount;
    }
  }

  if (Array.isArray(hit.variants)) {
    return hit.variants.length;
  }

  return null;
};

const getAlgoliaVariantId = (hit) => {
  const algoliaData = getAlgoliaData(hit);

  if (Array.isArray(hit.variants) && hit.variants.length === 1) {
    const variant = hit.variants[0];
    if (variant && typeof variant === "object") {
      return variant.id || variant.variant_id || variant.variantId || variant.objectID || null;
    }

    return variant;
  }

  return (
    hit.objectID ||
    hit.variant_id ||
    hit.variantId ||
    algoliaData.variant_id ||
    algoliaData.variantId ||
    algoliaData.default_variant_id ||
    algoliaData.defaultVariantId ||
    null
  );
};

const renderAlgoliaCardAction = (hit) => {
  // Buyers restricted to their company's My Items (b2b-catalog-scope.js) still
  // see the full catalogue in search, so a card for anything else must not
  // offer to add it — the cart would only refuse checkout afterwards.
  if (typeof window.jendcoB2BItemAllowed === "function" && !window.jendcoB2BItemAllowed(hit.id)) {
    return `<span class="algolia-card-action-btn" aria-disabled="true" style="opacity: 0.5; cursor: not-allowed;">Not available on your account</span>`;
  }

  const variantCount = getAlgoliaVariantCount(hit);
  const variantId = getAlgoliaVariantId(hit);

  if (variantCount === 1 && variantId) {
    return `
      <form method="post" action="/cart/add" class="algolia-card-action-form" novalidate="novalidate" data-type="add-to-cart-form" is="product-form">
        <input type="hidden" name="id" value="${variantId}" class="product-variant-id">
        <button type="submit" name="add" class="algolia-card-action-btn" aria-label="Add to cart">Add to cart</button>
      </form>
    `;
  }

  return `<a href="/products/${hit.handle}" class="algolia-card-action-btn">Choose options</a>`;
};
// Ship-date line under the card price, from the variant metafields Algolia indexes
// as meta.custom.availability_basis / availability_lead_days / next_available_date.
// A variant without them has no key at all on the record, never null. The basis
// matrix lives in window.AvailabilityShipDate (availability-ship-date.liquid, an
// inline script in the layout, so it is defined before this deferred file runs),
// which is what keeps these cards from drifting from the PDP and the cart.
//
// The slot is always rendered and one line tall, so the price row and the compare
// row keep lining up across a row whether or not a card has a date. It carries the
// theme's no-empty class because theme.css hides any empty div (div:empty) and an
// empty slot collapsing is exactly the misalignment the slot exists to prevent. Only
// single-variant products get a line, the same rule renderAlgoliaCardAction uses
// for Add to cart: the record is one variant, and a product-level card should not
// carry one variant's date. Quote-only cards show no price, so no ship date either.
const describeAlgoliaCardAvailability = (hit, isQuoteOnly) => {
  const resolver = window.AvailabilityShipDate;
  const custom = (hit.meta && hit.meta.custom) || {};
  if (!resolver || isQuoteOnly || getAlgoliaVariantCount(hit) !== 1) return null;
  // A variant that cannot be bought gets no ship date, matching the Liquid
  // snippet: Algolia's inventory_available is false when stock is tracked, at
  // zero and the policy is deny. Only an explicit false counts, so a record
  // without the field is treated as purchasable rather than silently hidden.
  if (hit.inventory_available === false) return null;
  const state = resolver.describe({
    basis: custom.availability_basis,
    leadDays: custom.availability_lead_days,
    nextDate: custom.next_available_date,
  }, 'card');
  return state && state.text ? state : null;
};

const renderAlgoliaCardAvailability = (hit, state) => {
  let line = '';
  if (state) {
    // state.text is theme copy around a theme-formatted date; nothing in it comes
    // from the record, which is why it can go in as HTML (it carries <strong>).
    // The attributes do come from the record and are escaped like every other
    // record value in this file.
    line = `<div class="product-availability-message algolia-card__availability" data-availability-message data-availability-style="card" data-variant-id="${jendcoEsc(hit.objectID)}" data-availability-basis="${jendcoEsc(state.basis)}"${state.shipNow ? ' data-availability-ship-now' : ''}${state.shipIso ? ` data-availability-ship-date="${jendcoEsc(state.shipIso)}"` : ''}><span class="product-availability-message__text" data-availability-message-text>${state.text}</span></div>`;
  }
  return `<div class="algolia-card__availability-slot no-empty">${line}</div>`;
};

// Card image. Algolia stores the product's original image (often 1280x1920),
// so it is served through Shopify's CDN resizing with a srcset, the same widths
// and sizes as snippets/collection-ssr-product-card.liquid: sharp on high-DPI
// screens without downloading the full original into a ~240px card.
const ALGOLIA_CARD_IMAGE_WIDTHS = [200, 300, 400, 500, 600, 800];
const ALGOLIA_CARD_IMAGE_SIZES = '(min-width: 1200px) 240px, (min-width: 990px) 22vw, (min-width: 750px) 30vw, 45vw';
const algoliaCardImage = (url, alt) => {
  let sized = null;
  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'cdn.shopify.com') {
      sized = (width) => {
        parsed.searchParams.set('width', width);
        return parsed.toString();
      };
    }
  } catch (e) {}
  if (!sized) return `<img src="${jendcoEsc(url)}" alt="${jendcoEsc(alt)}">`;
  const srcset = ALGOLIA_CARD_IMAGE_WIDTHS.map((width) => `${sized(width)} ${width}w`).join(', ');
  return `<img src="${jendcoEsc(sized(600))}" srcset="${jendcoEsc(srcset)}" sizes="${ALGOLIA_CARD_IMAGE_SIZES}" width="600" height="600" alt="${jendcoEsc(alt)}">`;
};

// What the merchant badge shows on an Algolia card. The same table as
// snippets/badge-display.liquid (keep the two in step), keyed on exact badge text.
// hasStock is true / false, or undefined when unknown: Algolia records carry
// inventory_available but no quantity, so only "cannot be bought" is known here.
// A card that states a ship date says "Available to Order" instead of a badge that
// contradicts the date (Call or Email, 28 Day Lead Time).
const algoliaBadgeDisplay = (text, { hasStock, shipDateShown } = {}) => {
  const badge = String(text || '').trim();
  switch (badge.toLowerCase()) {
    case '':
      return '';
    case 'in stock, ships quick!':
      return hasStock !== false ? badge : '';
    case 'call or email for availability!':
      if (hasStock === true) return 'In Stock, Ships Quick!';
      return shipDateShown ? 'Available to Order' : badge;
    case '28 day lead time from manufacturer':
      if (hasStock === true) return '';
      return shipDateShown ? 'Available to Order' : badge;
    case 'out of stock for season':
      return hasStock !== true ? badge : '';
    default:
      // Not Available Online / No Longer Available, and anything unrecognised.
      return badge;
  }
};
// Which badge text an Algolia card starts from, the same sources the server card
// (collection-ssr-product-card.liquid) uses. Each record carries its own variant's
// JSON (meta.custom.algolia_data) and the product-level badge (meta.custom.badge,
// Celigo's parent rollup, product metafield custom.badge). A multi-variant card
// stands for the product, so it shows the product badge: the record Algolia returns
// for a product can be any size, e.g. one marked "Out of Stock for Season" on a
// product with stock. A single-variant card shows its variant's badge and falls back
// to the product badge when the variant JSON has none (many hold only a SKU). If
// the product badge is absent (not indexed yet), behaviour is as before.
const algoliaCardBadgeSource = (hit, cardData) => {
  const custom = (hit && hit.meta && hit.meta.custom) || {};
  const productBadge = typeof custom.badge === 'string' ? custom.badge.trim() : '';
  const variantBadge = cardData && cardData.badge != null ? cardData.badge : '';
  const hasVariantBadge = String(variantBadge).trim() !== '';
  if ((getAlgoliaVariantCount(hit) || 1) > 1) return productBadge || variantBadge;
  return hasVariantBadge ? variantBadge : productBadge;
};
// Stock for the badge rules. A record's inventory_available describes its own
// size only, so for a multi-variant card (which shows the product badge) it says
// nothing about the product: one sold-out size would otherwise hide the product's
// "In Stock, Ships Quick!". Records carry no product-wide stock, so it is unknown
// there; single-variant cards keep their record's own answer.
const algoliaCardHasStock = (hit) => ((getAlgoliaVariantCount(hit) || 1) > 1 ? undefined : algoliaHitHasStock(hit));
const algoliaHitHasStock = (hit) => (hit.inventory_available === false ? false : undefined);
// End Algolia card action helpers.

// B2B card prices. The Algolia hit template leaves a placeholder for B2B buyers;
// this replaces it with sections/collection-ssr-price.liquid rendered for that
// product in the buyer's own session, i.e. the same Liquid price the server grid
// shows. One request per product, cached for the page's life, at most
// B2B_PRICE_CONCURRENCY at a time. Each card gives up B2B_PRICE_TIMEOUT_MS after it
// asked, queue time included, so a hung endpoint cannot leave the last cards of a
// page waiting several timeouts in a row. A failure or timeout shows a link to the
// product page, never the public price.
// Failures stay cached too: Algolia re-renders the same cards more than once per
// result, and re-asking a failing endpoint each time only doubles its load.
const B2B_PRICE_CONCURRENCY = 6;
const B2B_PRICE_TIMEOUT_MS = 8000;
const b2bPriceRequests = new Map();
const b2bPriceQueue = [];
let b2bPriceActive = 0;
const runB2BPriceQueue = () => {
  while (b2bPriceActive < B2B_PRICE_CONCURRENCY && b2bPriceQueue.length) {
    const job = b2bPriceQueue.shift();
    b2bPriceActive += 1;
    job().finally(() => {
      b2bPriceActive -= 1;
      runB2BPriceQueue();
    });
  }
};
const requestB2BCardPrice = (handle, deadline) => {
  const remaining = deadline - Date.now();
  if (remaining <= 0) return Promise.reject(new Error('price section timed out in queue'));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const controller = typeof AbortController === 'function' ? new AbortController() : null;
  const timer = setTimeout(() => { if (controller) controller.abort(); }, remaining);
  return fetch(`${root}products/${encodeURIComponent(handle)}?section_id=collection-ssr-price`, {
    credentials: 'same-origin',
    signal: controller ? controller.signal : undefined,
  })
    .then((response) => {
      if (!response.ok) throw new Error('price section ' + response.status);
      return response.text();
    })
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const price = doc.querySelector('[data-collection-ssr-price]');
      if (!price) throw new Error('price section empty');
      return price.innerHTML;
    })
    .finally(() => clearTimeout(timer));
};
const fetchB2BCardPrice = (handle) => {
  if (!b2bPriceRequests.has(handle)) {
    const deadline = Date.now() + B2B_PRICE_TIMEOUT_MS;
    b2bPriceRequests.set(handle, new Promise((resolve, reject) => {
      b2bPriceQueue.push(() => requestB2BCardPrice(handle, deadline).then(resolve, reject));
      runB2BPriceQueue();
    }));
  }
  return b2bPriceRequests.get(handle);
};
const fillB2BCardPrices = () => {
  document.querySelectorAll('#ProductGridContainer [data-b2b-price-pending]').forEach((pending) => {
    const handle = pending.getAttribute('data-b2b-price-pending');
    pending.removeAttribute('data-b2b-price-pending');
    const priceLine = pending.closest('.pro-price-stock');
    const card = pending.closest('.algolia-product-grid-box');
    fetchB2BCardPrice(handle)
      .then((html) => {
        if (!priceLine || !priceLine.isConnected) return;
        priceLine.innerHTML = html;
        const compare = card && card.querySelector('.compare_product');
        if (compare) compare.setAttribute('data-price', priceLine.textContent.replace(/\s+/g, ' ').trim());
      })
      .catch(() => {
        if (!priceLine || !priceLine.isConnected) return;
        priceLine.innerHTML = `<a href="/products/${jendcoEsc(encodeURIComponent(handle))}" class="collection-card-price-link">View your price</a>`;
      });
  });
};

// Keep keyboard focus when Algolia replaces what had it (e.g. its own pagination
// links re-render): move focus to the grid instead of dropping it on <body>.
let gridHadFocus = false;
document.addEventListener('focusin', (event) => {
  const wrapper = document.getElementById('ProductGridWrapper');
  gridHadFocus = !!(wrapper && wrapper.contains(event.target));
});
const restoreGridFocus = () => {
  if (!gridHadFocus) return;
  const active = document.activeElement;
  if (active && active !== document.body && active.isConnected) return;
  const grid = document.getElementById('ProductGridContainer');
  if (grid) grid.focus({ preventScroll: true });
};


const FACETS_ALLOWLIST = [
  'meta.custom.algolia_data.availability',
  // Brand and Category come from native Shopify fields, not the algolia_data JSON.
  // The JSON never carried a brand key, so the old
  // 'meta.custom.algolia_data.brand' entry matched nothing and Brand silently
  // dropped out of the sidebar. vendor is what the cards already print as the
  // brand; product_type is the merchandising category. Both are facetable in
  // the index as they stand.
  'vendor',
  'product_type',
  'meta.custom.algolia_data.size',
  'meta.custom.algolia_data.color',
  'meta.custom.algolia_data.model',
  'meta.custom.algolia_data.length',
  'meta.custom.algolia_data.capacity',
  'meta.custom.algolia_data.type',
  'meta.custom.algolia_data.hardware',
  'meta.custom.algolia_data.front_d_ring',
  'meta.custom.algolia_data.front_d_rings',
  'meta.custom.algolia_data.side_d_ring',
  'meta.custom.algolia_data.side_d_rings',
  'meta.custom.algolia_data.cal_rating',
  'meta.custom.algolia_data.power_source',
  'meta.custom.algolia_data.cfm_delivered',
  'meta.custom.algolia_data.max_airflow',
  'meta.custom.algolia_data.thickness',
  'meta.custom.algolia_data.ratings',
  'meta.custom.algolia_data.uom'
];

// Sidebar labels for attributes whose field name is not what a shopper would call
// them. Everything else is labelled from its key via toTitleCase. These labels
// must match FILTER_ORDER below, which already expects Brand and Category.
const FACET_LABELS = {
  vendor: 'Brand',
  product_type: 'Category',
};

// A filter with one option cannot narrow anything, and on a brand collection
// (every product one vendor) Brand would be exactly that. These two only show
// when the current collection or query has at least two values.
const FACET_MIN_VALUES = {
  vendor: 2,
  product_type: 2,
};

// Values fetched per filter. The catalogue has about 160 vendors and 130 product
// types, more than the default 100, which would silently drop brands on a broad
// search. The list still collapses to five behind "Show more".
const FACET_VALUE_LIMITS = {
  vendor: 300,
  product_type: 300,
};

const facetKeyOf = (attribute) => String(attribute).split('.').pop();
const facetLabelOf = (attribute) => {
  const key = facetKeyOf(attribute);
  return FACET_LABELS[key] || toTitleCase(key.replace(/_/g, ' '));
};
const facetValueLimitOf = (attribute) => FACET_VALUE_LIMITS[facetKeyOf(attribute)] || 100;

const FACET_EXCLUDE_KEYS = [
  'sku',
  'mpn',
  'upc',
  'badge',
  'offer',
  'is_featured'
];

searchClient
.search([
  {
    indexName: 'jendco-shopify_products',
    query: initialQuery,
    facets: FACETS_ALLOWLIST,
    // 1, not 0. The search proxy treats hitsPerPage 0 as a facet-only request
    // and rejects it without a collection filter or a query, which is exactly
    // the empty search page. The single hit is ignored; only facets are read.
    // Same fix as the catalogue scope probe in b2b-catalog-scope.js.
    hitsPerPage: 1,
    distinct: true,
    facetingAfterDistinct: true,
    filters: searchFilters()
  }
])
.then(({ results }) => {
  const res = results && results[0] ? results[0] : {};
  let refinements = [];
  const facets = res.facets || {};
  let FacetKeys = Object.keys(facets).filter(facet => {
    const key = facetKeyOf(facet);

    // The hide lists (shop custom.hide_global_filter, collection
    // custom.hide_filters) are written by people, so a filter can be hidden by
    // its field name or by the label shoppers see ("vendor" or "brand").
    return (
      FACETS_ALLOWLIST.includes(facet) &&
      !FACET_EXCLUDE_KEYS.includes(key) &&
      hide_filters.includes(key) === false &&
      hide_filters.includes(facetLabelOf(facet).toLowerCase()) === false
    );
  });
  

  left_FILTERS = FacetKeys
    .filter(attr => {
      const facetValues = facets[attr];
      const minValues = FACET_MIN_VALUES[facetKeyOf(attr)] || 1;
      return facetValues && Object.keys(facetValues).length >= minValues;
    })
    .map(attr => {
        return {
          label: facetLabelOf(attr),
          attribute: attr
        };
    });

  // Sort sidebar filters in a defined priority order. Labels listed in
  // FILTER_ORDER appear first in this exact order; any filters not listed
  // here fall to the bottom in their natural order.
  // NOTE: Labels must match EXACTLY what renders in the sidebar. Labels come
  // from FACET_LABELS when listed there (vendor → Brand, product_type →
  // Category), otherwise from the metafield key via toTitleCase, e.g.
  // `front_d_ring` → `Front D Ring`. To verify the current labels, run this
  // in the browser console on a collection page:
  //   [...document.querySelectorAll('.facets__wrapper-container .facets__summary-title')]
  //     .map(el => el.textContent.trim())
  const FILTER_ORDER = [
    'Availability',
    'Category',
    'Brand',
    'Size',
    'Color',
    'Model',
    'Length',
    'Capacity',
    'Type',
    'Hardware',
    'Front D Ring',
    'Side D Rings',
  ];

  left_FILTERS.sort((a, b) => {
    const indexA = FILTER_ORDER.indexOf(a.label);
    const indexB = FILTER_ORDER.indexOf(b.label);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  // if(left_FILTERS.length == 0){
  //   document.querySelector('.full-collection.enabled-sidebar').classList.remove('enabled-sidebar');
  // }
  left_FILTERS.forEach((filter, index) => {
    createSideFilter(filter, index, left_FILTERS.length)
  });
})
.catch(console.error);

if(isSearchPage){
  search_popular.addWidgets([
    configure({
      hitsPerPage: 10,
      distinct: true,
    }),
    hits({
      container: "#popular-prod",
      templates: {
        item(hit, { html, components }) {
          //console.log(hit,'hit')
          let title = hit.title;
          let sku_val = '',mpn_val = '',compare_val = '', badge = '', image = '', card_action = '';
          // Products without the custom.algolia_data metafield (new imports) must
          // still render: one throwing card blanks the whole hits list.
          const cardData_pop = getAlgoliaData(hit);
          const cardSku_pop = cardData_pop.sku || hit.sku;
          if(cardSku_pop){
            sku_val = `<div class="pro-sku">SKU: ${jendcoEsc(cardSku_pop)}</div>`;
          }
          if(cardData_pop.mpn){
            mpn_val = `<div class="pro-mpn">MPN: ${jendcoEsc(cardData_pop.mpn)}</div>`;
          }
          const hasAttribute = (arr, key) => arr.some(obj => obj[key] && obj[key].trim() !== "");
          if(!jendcoHideCompareAt() && hit.price < hit.compare_at_price){
            compare_val = `<span><s class="price-item price-item--regular">${FoxTheme.Currency.formatMoney(hit.compare_at_price * 100,theme.moneyFormat)}</s></span>`;
          }

          
          if(hit.image){
            image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary">${algoliaCardImage(hit.image, title)}</a>`;
          }else{
            image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg" alt="${title}"></a>`;
          }
          // Algolia card action: render the image overlay without placing forms/buttons inside links.
          card_action = renderAlgoliaCardAction(hit);
          const availabilityState_pop = describeAlgoliaCardAvailability(hit, false);
          const availability_pop = renderAlgoliaCardAvailability(hit, availabilityState_pop);

          const algoliaData_pop = (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data) ? hit.meta.custom.algolia_data : {};
          const badgeText_pop = algoliaBadgeDisplay(algoliaCardBadgeSource(hit, cardData_pop), { hasStock: algoliaCardHasStock(hit), shipDateShown: !!availabilityState_pop });
          if (badgeText_pop) badge = `<div class="pro-top-tag">${jendcoEsc(badgeText_pop)}</div>`;
          const algoliaJson_pop = JSON.stringify(algoliaData_pop).replace(/'/g, "&#39;");
          const storedIds_pop = (() => { try { return JSON.parse(localStorage.getItem('allProducts') || '[]').map(p => String(p.id)); } catch(e) { return []; } })();
          const isChecked_pop = storedIds_pop.includes(String(hit.id)) ? 'checked' : '';

            return `
            <div class="product-grid-box algolia-product-grid-box" dataVid="${hit.objectID}" data-id="${hit.id}">
                ${badge}
                <div class="pro-img-info">
                  <div class="algolia-card-media">
                    <div class="img-box">
                      ${image}
                    </div>
                    <div class="algolia-card-action-wrap">
                      ${card_action}
                    </div>
                  </div>
                  <div class="pro-item-info">
                    <div class="pro-brand-review">
                      <div class="pro-brand">${hit.vendor}</div>

                      <div class="" data-bv-show="inline_rating" data-bv-product-id="${hit.id}" data-bv-redirect-url="/products/${hit.handle}" data-bv-seo="false"></div>
                    </div>
                    <h2 class="product-grid-title">
                      <a href="/products/${hit.handle}" class="product-grid-title-link">${title}</a>
                    </h2>
                    <div class="sku-wrapper">
                      ${sku_val}${mpn_val}
                    </div>
                    <div class="pro-price-stock">
                      ${FoxTheme.Currency.formatMoney(hit.price * 100,theme.moneyFormat)}${compare_val}
                    </div>
                    ${availability_pop}
                  </div>
                </div>
              <label class="compare_product${isChecked_pop ? ' is-checked' : ''}" onclick="addCompare(event,this)"
                    data-id="${hit.id}"
                    data-vid="${hit.objectID}"
                    data-handle="${jendcoEsc(hit.handle)}"
                    data-brand="${jendcoEsc(hit.vendor)}"
                    data-title="${jendcoEsc(title)}"
                    data-sku="${jendcoEsc(algoliaData_pop.sku || '')}"
                    data-image="${jendcoEsc(hit.image || '')}"
                    data-price="${FoxTheme.Currency.formatMoney(hit.price * 100, theme.moneyFormat)}"
                    data-compareprice="${(!jendcoHideCompareAt() && hit.compare_at_price) ? FoxTheme.Currency.formatMoney(hit.compare_at_price * 100, theme.moneyFormat) : ''}"
                    data-algolia='${algoliaJson_pop}'>
                    <input type="checkbox" ${isChecked_pop}> Add To Compare
                  </label>
            </div>
          `;
        },
      },
      cssClasses: {
        root: "swiper pop-product",
        item: "product-grid-col swiper-slide",
        list: "product-grid-list in-stock-wrap on-sale-wrap swiper-wrapper",
      },
    }),
  ])
  search_popular.on('render', () => {
    var pop_slider = new window.FoxTheme.Carousel(".pop-product", {
      slidesPerView: 2,
      navigation: {
        nextEl: document.querySelector('.popular-products .swiper-controls .swiper-button-next'),
        prevEl: document.querySelector('.popular-products .swiper-controls .swiper-button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1440:{
          slidesPerView: 4,
        }
      },
    });
    pop_slider.init();
  })
}


search.on('render', () => {
  const algoliaSearchInput = document.querySelector('.ais-SearchBox-input');
  if (algoliaSearchInput) {
    algoliaSearchInput.setAttribute('aria-label', 'Search products');
  }

  const algoliaSearchSubmit = document.querySelector('.ais-SearchBox-submit');
  if (algoliaSearchSubmit) {
    algoliaSearchSubmit.setAttribute('aria-label', 'Submit product search');
  }

  const algoliaSearchReset = document.querySelector('.ais-SearchBox-reset');
  if (algoliaSearchReset) {
    algoliaSearchReset.setAttribute('aria-label', 'Clear product search');
  }
  
  if(isSearchPage){
    const results = search.helper.lastResults;
    const currentQuery = search.helper.state.query || '';
    // Nothing typed, nothing to correct. The suggestions index answers an empty
    // query with its most popular entry ("studson"), which always differs from
    // the empty query, so an empty search page used to ask "Looking for studson?".
    const suggestionLookup = currentQuery.trim() === ''
      ? Promise.resolve({ hits: [] })
      : qsClient.search(currentQuery, { hitsPerPage: 1 });
    suggestionLookup
    .then(({ hits }) => {
      if (
        hits.length > 0 && hits.length == 1 &&
        hits[0].query.toLowerCase() !== currentQuery.toLowerCase()
      ) {
        // Suggestions are built from what shoppers type, so they are escaped
        // like any other record data before going into markup.
        const suggestion = jendcoEsc(hits[0].query);
        const suggestionHref = '/search?query=' + encodeURIComponent(hits[0].query);
        if(suggestionContainer){
          suggestionContainer.innerHTML = `
          Looking for ${suggestion}?
          <a href="${suggestionHref}" class="search_collection-link__link link link--primary">Go to ${suggestion} collection 
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M5.25 2.1875L9.625 7L5.25 11.8125" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
          </a>
          `;
          suggestionContainer.parentElement.classList.remove('hide');
        }
      }else {
        if(suggestionContainer){
          suggestionContainer.textContent = '';
          suggestionContainer.parentElement.classList.add('hide'); 
        }
      }
    })
    .catch(err => {
      if(suggestionContainer){
        suggestionContainer.textContent = '';
        suggestionContainer.parentElement.classList.add('hide');
      }
    });
    
    if(results != null){
      if(results.hits.length == 0){
        var msg = 'No products found in this collection.';
        if(document.querySelector('.collection-template') == null){
          msg = 'No products found.';
        }
        document.querySelector('#FacetFiltersContainer').classList.add('!hidden');
        document.querySelector('#pagination').classList.add('!hidden');
        document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
        document.querySelector('.main-page-title').innerHTML = `No results found for <span>'${jendcoEsc(document.querySelector('.ais-SearchBox-input').value)}'</span>`;
        // document.querySelector('.main-page-title').classList.add('!hidden');
        //document.querySelector('.search_heading-section').classList.add('active');
        //document.querySelector('.search-suggestion-tab').classList.remove('hide');
        document.querySelector('.collection').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.remove('!hidden');
        document.querySelector('.popular-products').classList.remove('!hidden');

        qsClient
        .search(currentQuery, { hitsPerPage: 1 })
        .then(({ hits }) => {
          //console.log('dfjsdvfj',hits)
          if (hits.length > 1) {
            const suggestion = hits[0].query;
            if(suggestcollcontainer){
              suggestcollcontainer.querySelector('ul').innerHTML = `
                <li><a href="/search?query=${encodeURIComponent(suggestion)}">${jendcoEsc(suggestion)}</a></li>
              `;
              suggestcollcontainer.classList.remove('hide');
            }
          }else {
            document.querySelector('.main-page-title').classList.add('alone');
            if(suggestcollcontainer){
              suggestcollcontainer.querySelector('ul').textContent = ''; 
            }
          }
        })
        .catch(err => {
          if(suggestcollcontainer){
            suggestcollcontainer.querySelector('ul').textContent = '';
          }
        });
        search_popular.start();
      }else if(results.hits.length < 6){
        for(var t=0;t<results.hits.length;t++){
          if(results.hits[t].meta['shopify--discovery--product_recommendation']){
            var store_original_data = `${results.hits[t].meta['shopify--discovery--product_recommendation']['complementary_products']}`;
            const productIds = JSON.stringify(JSON.parse(store_original_data).map(gid => gid.split('/').pop()));
            var store_id = getSearchQueryString(`${productIds}`);
            fetch(`/search?view=recently-viewed-products&type=product&q=${store_id}`, {
              credentials: 'same-origin',
              method: 'GET'
            })
            .then(response => response.text())
            .then(content => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(content, 'text/html');
              const targetElement = doc.querySelector('#you-may-like-prod');
              document.querySelector('#you-may-like-prod-data .swiper-wrapper').innerHTML += targetElement.innerHTML;
            })
          }
          
          if(t == (results.hits.length - 1)){
            document.querySelector('.you-may-like-products').classList.remove('!hidden');
            var pop_slider = new window.FoxTheme.Carousel(".you-may-like-products .swiper", {
              slidesPerView: 2,
              navigation: {
                nextEl: document.querySelector('.you-may-like-products .swiper-controls .swiper-button-next'),
                prevEl: document.querySelector('.you-may-like-products .swiper-controls .swiper-button-prev'),
              },
              breakpoints: {
                768: {
                  slidesPerView: 3,
                },
                1440:{
                  slidesPerView: 4,
                }
              },
            });
            pop_slider.init();
          }
        }
        document.querySelector('.main-page-title').classList.remove('alone');
        document.querySelector('.popular-products').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.add('!hidden');
        document.querySelector('.search-suggestion-tab').classList.add('hide');
        document.querySelector('.collection').classList.remove('!hidden');
        document.querySelector('#FacetFiltersContainer').classList.remove('!hidden');
        document.querySelector('#pagination').classList.remove('!hidden');
        if(document.querySelector('.ais-SearchBox-input').value.trim().length > 0){
          document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
          document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${jendcoEsc(document.querySelector('.ais-SearchBox-input').value)}'</span>`;
          document.querySelector('.main-page-title').classList.remove('!hidden');
          // document.querySelector('.search_heading-section').classList.remove('active');
        }else{
          document.querySelector('.ais-SearchBox-submit').classList.remove('!hidden');
          document.querySelector('.main-page-title').classList.add('!hidden');
          // document.querySelector('.search_heading-section').classList.add('active');
        }
      }else{
        document.querySelector('.you-may-like-products').classList.add('!hidden');
        document.querySelector('.main-page-title').classList.remove('alone');
        document.querySelector('.popular-products').classList.add('!hidden');
        document.querySelector('.section-collection-list-slider').classList.add('!hidden');
        document.querySelector('.search-suggestion-tab').classList.add('hide');
        document.querySelector('.collection').classList.remove('!hidden');
        document.querySelector('#FacetFiltersContainer').classList.remove('!hidden');
        document.querySelector('#pagination').classList.remove('!hidden');
        if(document.querySelector('.ais-SearchBox-input').value.trim().length > 0){
          document.querySelector('.ais-SearchBox-submit').classList.add('!hidden');
          document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${jendcoEsc(document.querySelector('.ais-SearchBox-input').value)}'</span>`;
          document.querySelector('.main-page-title').classList.remove('!hidden');
          // document.querySelector('.search_heading-section').classList.remove('active');
        }else{
          document.querySelector('.ais-SearchBox-submit').classList.remove('!hidden');
          document.querySelector('.main-page-title').classList.add('!hidden');
          // document.querySelector('.search_heading-section').classList.add('active');
        }
      }
    }
  }
})

var r = "";

sideFilterWrapper.forEach((all_price_filter) => {
  all_price_filter.innerHTML += `
  <details class="disclosure-has-popup facets__filter-dropdown facets__disclosure js-filter" id="price-facet" data-index="00">
    <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-00">
      <div class="facets__summary-inner">
        <div class="facets__summary-title re-le-sp-2 font-blod">Price</div>
        <div class="facets__summary-icon">
          <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 10L8 5L13.5 10" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 6L8 11L13.5 6" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </summary>
    <div id="Facet-00" class="facets__display">
      <div class="panel" id="range-slider"><div class="sliders_control"></div></div>
    </div>
  </details>
  `;
})

facetsWrappermobile.forEach((mobileFilterWrapper) => {
  const mobilePriceFilter = document.createElement('details');
  mobilePriceFilter.className = 'mobile-facets__details js-filter';
  mobilePriceFilter.id = 'mobile-price-facet';
  mobilePriceFilter.setAttribute('data-index', 'mobile-algolia-price');
  mobilePriceFilter.innerHTML = `
    <summary class="mobile-facets__summary" role="button" aria-expanded="false" aria-controls="FacetMobile-Mobile-price">
      <div>
        <span>Price</span>
        <span class="mobile-facets__arrow no-js-hidden">
          <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
            <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <noscript>
          <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
            <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </noscript>
      </div>
    </summary>
    <div id="FacetMobile-Mobile-price" class="mobile-facets__submenu">
      <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
        <svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1L5 4.5L8.5 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        Price
      </button>
      <div class="mobile-facets__submenu-items" id="Facet-mobile-price">
        <div class="panel" id="range-slider-mobile"><div class="sliders_control_mobile"></div></div>
      </div>
    </div>
  `;
  mobileFilterWrapper.appendChild(mobilePriceFilter);
});

search.addWidgets([
  customRangeSlider({
    container: document.querySelector(".sliders_control"),
    attribute: "price",
  }),
]);

search.addWidgets([
  customRangeSliderMobile({
    container: document.querySelector(".sliders_control_mobile"),
    attribute: "price",
  }),
]);

const mainSearchWidgets = [
  searchBox({
  container: "#searchbox",
  placeholder: "Search for products",
  queryHook(query, search) {
    search(query);
  },
    templates: {
      submit({ cssClasses }, { html }) {
        return html`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none"><path d="M5.66457 11.501C6.84789 11.5008 7.99711 11.1046 8.92924 10.3757L11.8599 13.3063L12.8026 12.3637L9.87191 9.43302C10.6012 8.50079 10.9976 7.35131 10.9979 6.16768C10.9979 3.22702 8.60524 0.834351 5.66457 0.834351C2.7239 0.834351 0.331238 3.22702 0.331238 6.16768C0.331238 9.10835 2.7239 11.501 5.66457 11.501ZM5.66457 2.16768C7.87057 2.16768 9.66457 3.96168 9.66457 6.16768C9.66457 8.37368 7.87057 10.1677 5.66457 10.1677C3.45857 10.1677 1.66457 8.37368 1.66457 6.16768C1.66457 3.96168 3.45857 2.16768 5.66457 2.16768Z" fill="#001424"></path></svg>`;
      },
    },
  }),
  customCurrentRefinements({
    container: "#current-refinements",
  }),
  // clearRefinements({
  //   container: "#clear-refinements",
  //   templates: {
  //     resetLabel({ hasRefinements }, { html }) {
  //       return html`<span>${
  //         hasRefinements ? "Clear all" : "Clear all"
  //       }</span>`;
  //     },
  //   },
  // }),
  customClearRefinements({}),
  configure({
    hitsPerPage: 20,
    distinct: true,
    facetingAfterDistinct: true,
    filters: searchFilters(),
  }),
  customSortBy({
    container: document.querySelector("#sort-by1"),
    items: [
      {
        label: "Relevance",
        value: "jendco-shopify_products",
      },
      {
        label: "Price: Low to High",
        value: "jendco-shopify_products_price_asc",
      },
      {
        label: "Price: High to Low",
        value: "jendco-shopify_products_price_desc",
      },
      {
        label: "Best Selling",
        value: "shopify_best_selling",
      },
      {
        label: "Newest",
        value: "shopify_newest",
      },
      {
        label: "Name: A-Z",
        value: "shopify_az",
      },
      {
        label: "Name: Z-A",
        value: "shopify_za",
      },
    ],
  }),
  customSortBy2({
    container: document.querySelector("#sort-by2"),
    items: [
      {
        label: "Relevance",
        value: "jendco-shopify_products",
      },
      {
        label: "Price: Low to High",
        value: "jendco-shopify_products_price_asc",
      },
      {
        label: "Price: High to Low",
        value: "jendco-shopify_products_price_desc",
      },
      {
        label: "Best Selling",
        value: "shopify_best_selling",
      },
      {
        label: "Newest",
        value: "shopify_newest",
      },
      {
        label: "Name: A-Z",
        value: "shopify_az",
      },
      {
        label: "Name: Z-A",
        value: "shopify_za",
      },
    ],
  }),
  customStats({
    container: document.querySelector("#ProductCount"),
    templates: {
      resetLabel({ hasRefinements }, { html }) {
        return html`<span>${
          hasRefinements ? "Clear all" : "Clear all"
        }</span>`;
      },
    }
  }),
  collectionGridHits = hits({
    container: algoliaGridRoot,
    templates: {
      item(hit, { html, components }) {
        //console.log(hit.meta.custom.algolia_data,'hit')
        let title = hit.title;
        let sku_val = '',mpn_val = '',compare_val = '', badge = '', image = '', chk_sku = '', card_action = '';
        // Products without the custom.algolia_data metafield (new imports) must
        // still render: one throwing card blanks the whole grid. SKU falls back to
        // the variant SKU, as the server-rendered card does.
        const cardData_grid = getAlgoliaData(hit);
        const cardSku_grid = cardData_grid.sku || hit.sku;
        if(cardSku_grid){
          sku_val = `<div class="pro-sku">SKU: ${jendcoEsc(cardSku_grid)}</div>`;
          chk_sku = 'active';
        }
        if(cardData_grid.mpn){
          mpn_val = `<div class="pro-mpn">MPN: ${jendcoEsc(cardData_grid.mpn)}</div>`;
        }
        const hasAttribute = (arr, key) => arr.some(obj => obj[key] && obj[key].trim() !== "");
        if(!jendcoHideCompareAt() && hit.price < hit.compare_at_price){
          compare_val = `<span><s class="price-item price-item--regular">${FoxTheme.Currency.formatMoney(hit.compare_at_price * 100,theme.moneyFormat)}</s></span>`;
        }

        
        if(hit.image){
          image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary">${algoliaCardImage(hit.image, title)}</a>`;
        }else{
          image = `<a href="/products/${hit.handle}" class="product-item__image-wrapper product-item__image-wrapper--with-secondary"><img src="https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg" alt="${title}"></a>`;
        }
        
        // Algolia card action: render the image overlay without placing forms/buttons inside links.
        card_action = renderAlgoliaCardAction(hit);

        const algoliaData_grid = (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data) ? hit.meta.custom.algolia_data : {};
        const algoliaJson_grid = JSON.stringify(algoliaData_grid).replace(/'/g, "&#39;");
        const storedIds_grid = (() => { try { return JSON.parse(localStorage.getItem('allProducts') || '[]').map(p => String(p.id)); } catch(e) { return []; } })();
        const isChecked_grid = storedIds_grid.includes(String(hit.id)) ? 'checked' : '';
        const quoteOnlyMeta_grid = hit.meta && hit.meta.custom ? hit.meta.custom.quote_only : undefined;
        const isQuoteOnly_grid = quoteOnlyMeta_grid === true || quoteOnlyMeta_grid === 'true';
        // Algolia records carry the public price. A B2B buyer is priced by their
        // company catalog, so their cards show a placeholder that
        // fillB2BCardPrices() replaces with the Liquid-rendered price.
        const b2bPriced_grid = jendcoHideCompareAt() && !isQuoteOnly_grid;
        const price_val = isQuoteOnly_grid
          ? '<span class="pro-price-stock--quote-only">Request a Quote</span>'
          : b2bPriced_grid
            ? `<span class="collection-card-price-pending" data-b2b-price-pending="${jendcoEsc(hit.handle)}">Loading your price…</span>`
            : `${FoxTheme.Currency.formatMoney(hit.price * 100,theme.moneyFormat)}${compare_val}`;
        const availabilityState_grid = describeAlgoliaCardAvailability(hit, isQuoteOnly_grid);
        const availability_grid = renderAlgoliaCardAvailability(hit, availabilityState_grid);
        const badgeText_grid = algoliaBadgeDisplay(algoliaCardBadgeSource(hit, cardData_grid), { hasStock: algoliaCardHasStock(hit), shipDateShown: !!availabilityState_grid });
        if (badgeText_grid) badge = `<div class="pro-top-tag">${jendcoEsc(badgeText_grid)}</div>`;

          return `
          <div class="product-grid-box algolia-product-grid-box" dataVid="${hit.objectID}" data-id="${hit.id}">
              ${badge}
              <div class="pro-img-info">
                  <div class="algolia-card-media">
                    <div class="img-box">
                      ${image}
                    </div>
                    <div class="algolia-card-action-wrap">
                      ${card_action}
                    </div>
                  </div>
                  <div class="pro-item-info">
                    <div class="pro-brand-review">
                      <div class="pro-brand">${hit.vendor}</div>
                      <div class="" data-bv-show="inline_rating" data-bv-product-id="${hit.id}" data-bv-redirect-url="/products/${hit.handle}" data-bv-seo="false"></div>
                    </div>
                    <h2 class="product-grid-title">
                      <a href="/products/${hit.handle}" class="product-grid-title-link">${title}</a>
                    </h2>
                    <div class="sku-wrapper ${chk_sku}">
                      ${sku_val}${mpn_val}
                    </div>
                    <div class="pro-price-stock">
                      ${price_val}
                    </div>
                    ${availability_grid}
                  </div>
              </div>
            <label class="compare_product${isChecked_grid ? ' is-checked' : ''}" onclick="addCompare(event,this)"
              data-id="${hit.id}"
              data-vid="${hit.objectID}"
              data-handle="${jendcoEsc(hit.handle)}"
              data-brand="${jendcoEsc(hit.vendor)}"
              data-title="${jendcoEsc(title)}"
              data-sku="${jendcoEsc(algoliaData_grid.sku || '')}"
              data-image="${jendcoEsc(hit.image || '')}"
              data-price="${b2bPriced_grid ? '' : FoxTheme.Currency.formatMoney(hit.price * 100, theme.moneyFormat)}"
              data-compareprice="${(!jendcoHideCompareAt() && hit.compare_at_price) ? FoxTheme.Currency.formatMoney(hit.compare_at_price * 100, theme.moneyFormat) : ''}"
              data-algolia='${algoliaJson_grid}'>
              <input type="checkbox" ${isChecked_grid}> Add To Compare
            </label>
          </div>
        `;
      },
    },
    cssClasses: {
      item: "product-grid-col",
      list: "product-grid-list in-stock-wrap on-sale-wrap",
    },
    transformItems(items) {
      // Until Algolia owns the grid, paint nothing from a stale render: keep the
      // server products until results for the shopper's new state arrive.
      if (serverOwnsGrid && !serverRenderedGridReleased && !isFreshRender()) return [];
      releaseServerRenderedGrid();
      return items;
    },
  }),
  collectionGridPagination = pagination({
    container: algoliaPaginationRoot,
    showFirst: false,
    showLast: false,
    templates: {
      previous: '< Prev',
      next: 'Next >',
    },
  }),
];

// On a server-owned collection URL without Algolia state, the grid widgets wait
// for a deliberate filter, sort or search (onStateChange, popstate) — except for a
// buyer restricted to My Items, whose grid Algolia owns from the start.
const deferGridWidgets = serverOwnsGrid && !urlCarriesAlgoliaState() && !algoliaOwnsRestrictedGrid;
if (!deferGridWidgets) gridWidgetsMounted = true;
// The section's inline script pends a restricted buyer's grid expecting Algolia to
// take it (it decides in Liquid, before this file runs). If this buyer's search is
// not narrowed after all, the server grid, which hides every other product itself,
// is the page: show it now rather than after the inline script's 10 s timer.
if (deferGridWidgets && ssrGridControl && gridWrapper &&
    gridWrapper.classList.contains('collection-ssr-pending')) {
  ssrGridControl.reveal(true);
}
search.addWidgets(mainSearchWidgets.filter((widget) =>
  !deferGridWidgets || (widget !== collectionGridHits && widget !== collectionGridPagination)
));

search.on('error', (event) => {
  revealServerRenderedGrid();
  console.error('Algolia search failed', event && event.error ? event.error : event);
});

search.on('render', () => {
  fillB2BCardPrices();
  restoreGridFocus();
});

search.start();
// From here the error handler above, or the inline script's timer, recovers a
// pending grid; before it, the inline script's DOMContentLoaded check does.
if (ssrGridControl) ssrGridControl.searchStarted = true;





if (initialQuery) {
  search.helper.setQuery(initialQuery).search();
  // console.log(initialQuery,'initialQuerytext')
  // document.querySelector('.main-page-title').innerHTML = `${document.querySelector('#ProductCount').dataset.count} Results for <span>'${initialQuery}'</span>`;
  //document.querySelector('.main-page-title').innerText = 'Search Results for "' + initialQuery + '"';
  // document.querySelector('.header__left .search-box form input').value = initialQuery;
}

const selectedFiltersContainer = document.querySelector('.active-facets');

document.addEventListener("algolia.autocomplete.afterInit", function () {
  console.log("Autocomplete.js has been initialized");
});

function toTitleCase(str) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1));
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max - to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;
  controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
}

function toggleClass(ele){
  ele.classList.toggle('active');
}

function closeActive(ele){
  document.querySelector('.selected-sort').textContent = ele.textContent;
  document.querySelector('.selected-sort').classList.remove('active')
}

function createFacetInputId(prefix, filterIndex, optionIndex, label) {
  const safeLabel = String(label)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `${prefix}-Filter-${filterIndex}-${optionIndex}-${safeLabel || 'option'}`;
}

function createSideFilter(filter, index, total) {

  var class_name = '';
  if(filter.label == 'Availability'){
    class_name = 'facet_availability';
  }
    
  if(document.querySelector('#col_side_filter') && document.querySelector('#col_side_filter').value != ''){
    var curr_filter = filter.label.toLocaleLowerCase().replaceAll(' ','-');
    var side_filter_ignor = document.querySelector('#col_side_filter').value.toLocaleLowerCase().replaceAll(' ','-').split(',');
    if(side_filter_ignor.includes(curr_filter)){
      return;
    }
  }
  const wrapper = document.createElement('details');
  wrapper.className = `disclosure-has-popup facets__filter-dropdown facets__disclosure js-filter ${class_name}`;
  wrapper.id = `Details-sidefilter-${index}`;
  wrapper.setAttribute('data-index', index);

  wrapper.innerHTML = `
    <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-${index}">
      <div class="facets__summary-inner">
        <div class="facets__summary-title re-le-sp-2 font-blod">${filter.label}</div>
        <div class="facets__summary-icon">
          <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 10L8 5L13.5 10" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2.5 6L8 11L13.5 6" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </summary>
    <div id="Facet-${index}" class="facets__display">
      <ul class="facets__list list-unstyled ${class_name}" role="list" id="side-facet-list-${index}"></ul>
    </div>
  `;

  const wrappermobile = document.createElement('details');
  wrappermobile.className = 'mobile-facets__details js-filter';
  wrappermobile.id = `Details-Mobile-${index}`;
  wrappermobile.setAttribute('data-index', `mobile-algolia-${index}`);

  wrappermobile.innerHTML = `<summary class="mobile-facets__summary" role="button" aria-expanded="false" aria-controls="FacetMobile-Mobile-${index}">
        <div>
          <span>${filter.label}</span>
          <span class="mobile-facets__arrow no-js-hidden">
            <svg class="icon icon-caret"  xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
              <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <noscript>
            <svg class="icon icon-caret"  xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
              <path d="M0.600098 0.600098L6.1001 5.6001L11.6001 0.600098" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </noscript>
        </div>
      </summary>
      <div id="FacetMobile-Mobile-${index}" class="mobile-facets__submenu">
        <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
          <svg class="icon icon-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 1L5 4.5L8.5 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          ${filter.label}
        </button>
        <div class="mobile-facets__submenu-items" id="Facet-mobile-${index}">
          <ul class="mobile-facets__list list-unstyled" role="list" style="--image_filter_columns: 4;" id="side-facet-list-mobile-${index}"></ul>
        </div>
      </div>`

  sideFilterWrapper.forEach((filterwrapper) =>{
    filterwrapper.appendChild(wrapper);
  })

  facetsWrappermobile.forEach((filterwrappermobile) =>{
    filterwrappermobile.appendChild(wrappermobile);
  })

  // if(index == (total - 1)){
  //   customElements.define('menu-drawer', MenuDrawer)
  // }

  search.addWidgets([
    instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
      var store_original_index = index;
      const { items, refine } = renderOptions;
      const ul = document.getElementById(`side-facet-list-${store_original_index}`);
      ul.innerHTML = '';

      // For the Availability filter, hide the "Back in Stock Soon" value.
      // Only "In Stock" should be exposed to shoppers.
      let filteredItems = items;
      if (filter.attribute === 'meta.custom.algolia_data.availability') {
        filteredItems = items.filter(item =>
          item.label.toLowerCase() !== 'back in stock soon'
        );
      }

      // Sort: (1) active/refined items on top,
      //       (2) for Yes/No filters, Yes before No,
      //       (3) otherwise alphabetical A–Z.
      const sortedItems = [...filteredItems].sort((a, b) => {
        if (a.isRefined && !b.isRefined) return -1;
        if (!a.isRefined && b.isRefined) return 1;
        const aLower = a.label.toLowerCase();
        const bLower = b.label.toLowerCase();
        if (aLower === 'yes' && bLower === 'no') return -1;
        if (aLower === 'no' && bLower === 'yes') return 1;
        return a.label.localeCompare(b.label, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });

      sortedItems.forEach((item,index) => {
        const li = document.createElement('li');
        if(index > 4){
          li.className = 'list-menu__item facets__item !hidden';
        }else{
          li.className = 'list-menu__item facets__item';
        }
        
        const id = createFacetInputId('Side', store_original_index, index, item.label);

        let label = item.label;
        li.innerHTML = `
          <input type="checkbox" class="focus-inset" value="${jendcoEsc(item.value)}" id="${id}" ${item.isRefined ? 'checked' : ''}>
          <label for="${id}" class="facet-checkbox re-le-sp-1">
            <span class="icon icon-checkmark"></span>
            <span class="facet-checkbox__label">${jendcoEsc(label)}</span>
            
          </label>
          <span class="value-count">(${item.count})</span>
        `;

        li.querySelector('input').addEventListener('change', () => {
          refine(item.value);
          // Update UI after checkbox change
          // updateFilterUI(wrapper, filter.attribute); // Removed this line
        });

        ul.appendChild(li);
        
      });

      if(items.length > 5){
        const closestDisplay = ul.closest('.facets__display');
        if (closestDisplay) {
          const oldButton = closestDisplay.querySelector('span.show_more-button');
          if(oldButton) oldButton.remove();
        }
        const showMoreContainer = document.createElement('span');
        showMoreContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" class="icon icon-plus">
            <path d="M5.83329 0.833333C5.83329 0.373096 5.4602 0 4.99996 0C4.53972 0 4.16663 0.373096 4.16663 0.833333L4.16663 9.16667C4.16663 9.6269 4.53972 10 4.99996 10C5.4602 10 5.83329 9.6269 5.83329 9.16667L5.83329 0.833333Z" fill="currentColor"></path>
            <path d="M9.16667 5.83341C9.6269 5.83341 10 5.46032 10 5.00008C10 4.53984 9.6269 4.16675 9.16667 4.16675L0.833334 4.16675C0.373096 4.16675 0 4.53984 0 5.00008C0 5.46032 0.373096 5.83341 0.833334 5.83341L9.16667 5.83341Z" fill="currentColor"></path>
          </svg>
          <span class="text">Show more</span>
          <span class="num-of_filter" data-number="${(items.length - 5)}"></span>`;
        showMoreContainer.className = 'show_more-button';
        showMoreContainer.onclick = ShowMore;
        if (closestDisplay) closestDisplay.appendChild(showMoreContainer);
      }

      if(items.length == 0){
        wrapper.classList.add('hidden');
      }else{
        wrapper.classList.remove('hidden');
      }

      // Initial UI update
      if (!isFirstRender) {
        //updateFilterUI(wrapper, filter.attribute);
      }

    })({
      container: `#side-facet-list-${index}`,
      attribute: filter.attribute,
      limit: facetValueLimitOf(filter.attribute)
    })
  ]);

  search.addWidgets([
    instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
      var store_original_index = index;
      const { items, refine } = renderOptions;
      const ul = document.getElementById(`side-facet-list-mobile-${store_original_index}`);
      ul.innerHTML = '';

      // For the Availability filter, hide the "Back in Stock Soon" value.
      // Only "In Stock" should be exposed to shoppers.
      let filteredItems = items;
      if (filter.attribute === 'meta.custom.algolia_data.availability') {
        filteredItems = items.filter(item =>
          item.label.toLowerCase() !== 'back in stock soon'
        );
      }

      // Sort: (1) active/refined items on top,
      //       (2) for Yes/No filters, Yes before No,
      //       (3) otherwise alphabetical A–Z.
      const sortedItems = [...filteredItems].sort((a, b) => {
        if (a.isRefined && !b.isRefined) return -1;
        if (!a.isRefined && b.isRefined) return 1;
        const aLower = a.label.toLowerCase();
        const bLower = b.label.toLowerCase();
        if (aLower === 'yes' && bLower === 'no') return -1;
        if (aLower === 'no' && bLower === 'yes') return 1;
        return a.label.localeCompare(b.label, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });

      sortedItems.forEach((item, index) => {
        const li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        const id = createFacetInputId('Mobile', store_original_index, index, item.label);

        let label = item.label;
        li.innerHTML = `
          <input type="checkbox" class="focus-inset" value="${jendcoEsc(item.value)}" id="${id}" ${item.isRefined ? 'checked' : ''}>
          <label for="${id}" class="facet-checkbox re-le-sp-1">
            <span class="icon icon-checkmark"></span>
            <span class="facet-checkbox__label">${jendcoEsc(label)}</span>
            
          </label>
          <span class="value-count">(${item.count})</span>
        `;

        li.querySelector('input').addEventListener('change', () => {
          refine(item.value);
          // Update UI after checkbox change
          // updateFilterUI(wrapper, filter.attribute); // Removed this line
        });

        ul.appendChild(li);
      });

      if(items.length == 0){
        wrappermobile.classList.add('hidden');
      }else{
        wrappermobile.classList.remove('hidden');
      }

      // Initial UI update
      if (!isFirstRender) {
        //updateFilterUI(wrapper, filter.attribute);
      }

    })({
      container: `#side-facet-list-mobile-${index}`,
      attribute: filter.attribute,
      limit: facetValueLimitOf(filter.attribute)
    })
  ]);
}

function ShowMore(ele){
  const ul = ele.target.closest('.facets__display').querySelector('ul');
  const liItems = ul.querySelectorAll('li');
  const showMoreBtn = ele.target;
  showMoreBtn.classList.toggle('active');

  const anyHidden = Array.from(liItems).some(li => li.classList.contains('!hidden'));

  if (anyHidden) {
    liItems.forEach(li => li.classList.remove('!hidden'));
    showMoreBtn.textContent = 'Show less';
  } else {
    liItems.forEach((li, i) => {
      if (i > 4) {
        li.classList.add('!hidden');
      }
    });
    showMoreBtn.textContent = 'Show more';
  }
}

function getSearchQueryString(dataItems) {
  let items = JSON.parse(dataItems);

  return items.map(item => `id:${item}`).join(' OR ');
}
}
